export const LANGUAGE_ENGLISH = 'en';
export const LANGUAGE_ARABIC = 'ar';